import OpenInvestmentsSection from './OpenInvestmentsSection';

export default OpenInvestmentsSection;
